<template>
  <div class="info">
    <h3>消息详情</h3>
    <div class="content" v-for="item in messageList" :key="item.id">
      <p class="inform">{{item.title}}</p>
      <p class="time">{{item.createDate}}</p>
      <!--<img class="img" src="" alt="">-->
      <p class="text">{{item.content}}</p>
    </div>
  </div>
</template>

<script>
import {reqMessageSub} from '../../../api'
export default {
  data() {
    return {
      messageList: []
    }
  },
  created() {
    reqMessageSub().then(res => {
      if(res.code === 200) {
        this.messageList = res.data.bussData
      }
    })
  }
}
</script>

<style scoped lang="less" type="text/less">
.info{
  h3{
    font-size: 24px;
    margin-top:60px;
  }
  .content{
    width: 100%;
    margin-top:39px;
    padding:30px 20px 162px;
    box-sizing: border-box;
    box-shadow:0px 3px 9px 0px rgba(0, 0, 0, 0.09);
    border-radius:10px;
    .inform{
      font-size: 16px;
      font-weight: bold;
      text-align: center;
    }
    .time{
      color:#999;
      margin-top:14px;
      text-align:center;
    }
    .img{
      display: block;
      width: 860px;
      height: 240px;
      margin-top:20px;
      background: #eee;
    }
    .text{
      margin-top:18px;
      line-height: 22px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Person/Children/Info.vue